// src/modules/app-views/_apps/appmulti/receivables/pages/Init/components/tableColumns/customerColumn.js
import translateX from 'utils/translateX';

function customerColumn(buildColumnProps, options = {}) {
  const {
    key = 'customer',
    title = 'customer',
    dataIndex = '__customer',
    width = 240,
    columnProps = {},
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    ...(width && { width }),
    ...buildColumnProps(dataIndex, columnProps),
    render: (_, r) => {
      const name = r?.__customer?.name || r?.__customer?.fullName;
      if (!name) return <span className="text-muted">—</span>;
      return <span className="font-weight-semibold">{name}</span>;
    },
  };
}

export default customerColumn;
